import React, { useEffect, useState } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'

import { getPlanModalProps } from '../../../lib/plans'
import { LIMITED_ACCESS_ROLES, MAP_LAYER_IDS, MAP_MODES, SIDEBAR_VIEWS } from '../../../lib/constants'
import ghAnalytics from '../../../lib/analytics'
import HistoricalRestrictionModal from '../../Modals/HistoricalRestrictionModal'
import SceneDisabledModal from '../../Modals/SceneDisabledModal'
import styles from './TwoDThreeDToggle.module.scss'
import UserPlanModal from '../../Modals/UserPlanModal'

function TwoDThreeDToggle(props) {
  const [toggleMode, setToggleMode] = useState(MAP_MODES.TwoD)
  useEffect(() => {
    props.map.ground.layers.forEach(layer => {
      layer.visible = true
    })
  }, [])

  const userPlanModal = props => {
    const userPlan = getPlanModalProps(props)
    setTimeout(() => {
      props.dispatch({
        type: 'modals/add',
        payload: {
          props: userPlan,
          component: UserPlanModal
        }
      })
    }, 250)
  }

  const displayRestritcedModal = () => {
    let payloadComponent = null
    if (props.sceneDisabled) {
      payloadComponent = SceneDisabledModal
    } else if (props.isHistoricalView) {
      payloadComponent = HistoricalRestrictionModal
    }
    if (payloadComponent) {
      props.dispatch({
        type: 'modals/add',
        payload: {
          component: payloadComponent
        }
      })
    }
  }

  const setMapView = mode => {
    props.dispatch({
      type: 'toast/show',
      payload: {
        text: `Switching map to ${mode}...`,
        loader: true
      }
    })
    props.dispatch({
      type: 'app/setShowSidebar',
      payload: false
    })
    props.dispatch({
      type: 'map/resetWidgetState'
    })
    props.dispatch({
      type: 'features/setFeaturesLoading',
      payload: true
    })
    props.dispatch({
      type: 'features/setCollectionsLoading',
      payload: true
    })
    setTimeout(() => {
      props.dispatch({
        type: 'map/changeMapMode',
        payload: mode
      })
      props.dispatch({
        type: 'map/setAllFeatureGraphicsVisibility',
        payload: {
          layerId: MAP_LAYER_IDS.content,
          visibility: false
        }
      })
    }, 250)
    if (mode === MAP_MODES.ThreeD) {
      ghAnalytics.logThreeDToggled()
    } else if (mode === MAP_MODES.TowD) {
      ghAnalytics.logTwoDToggled()
    }
  }

  const getStyle = buttonMode => {
    let style = `esri-widget--button ${styles.toggleButton}`
    if (toggleMode === buttonMode) {
      style += ' ' + `${styles.toggleButtonSelected} selected`
    }
    return style
  }

  const onClickTwoD = () => {
    if (toggleMode !== MAP_MODES.TwoD) {
      setToggleMode(MAP_MODES.TwoD)
      setTimeout(() => {
        setMapView(MAP_MODES.TwoD)
      }, 100)
      ghAnalytics.logTwoDToggled()
    }
  }

  const onClickThreeD = () => {
    const role = props.userProfile.roles[0]
    if (LIMITED_ACCESS_ROLES.includes(role)) {
      userPlanModal(props)
    } else {
      if (props.sceneDisabled || props.isHistoricalView) {
        displayRestritcedModal()
      } else {
        if (toggleMode !== MAP_MODES.ThreeD) {
          setToggleMode(MAP_MODES.ThreeD)
          setTimeout(() => {
            setMapView(MAP_MODES.ThreeD)
          }, 100)
          ghAnalytics.logThreeDToggled()
        }
      }
    }
  }

  return (
    <div className={styles.toggleButtonsContainer} style={{ visibility: props.isUpdatingLocation ? 'hidden' : 'visible' }}>
      <div onClick={onClickTwoD} className={getStyle(MAP_MODES.TwoD)}>
        <span>2D</span>
      </div>
      <div onClick={onClickThreeD} className={getStyle(MAP_MODES.ThreeD)}>
        <span className={props.is3DRestricted ? styles.disabledText : ''}>3D</span>
      </div>
    </div>
  )
}

TwoDThreeDToggle.propTypes = {
  is3DRestricted: PropTypes.bool,
  isHistoricalView: PropTypes.bool,
  isUpdatingLocation: PropTypes.bool,
  map: PropTypes.object,
  sceneDisabled: PropTypes.bool,
  userProfile: PropTypes.object
}

export default connect(model => {
  const { sidebarView } = model.app
  const { isUpdatingLocation, mapMode, sceneError } = model.map
  const { profile: userProfile } = model.user
  const isTwoDMode = mapMode === MAP_MODES.TwoD
  const isHistoricalView = sidebarView.view === SIDEBAR_VIEWS.HistoricalImagery
  const sceneDisabled = sceneError != null
  const is3DRestricted = (isHistoricalView || sceneDisabled) && isTwoDMode
  return {
    is3DRestricted,
    isHistoricalView,
    isUpdatingLocation,
    sceneDisabled,
    userProfile
  }
})(TwoDThreeDToggle)
